import React, {FC, useEffect, useState} from 'react'
import MetaTags from "react-meta-tags"
import {useParams} from "react-router-dom"
import * as Yup from "yup"
import {codeCheck, codeSend} from "../../api"
import getLocalizeString from "../../utils/getLocalizeString"
import redirect from '../../utils/redirect'
import Form2Auth from "../Form2Auth"
import Button from "../Button"
import {useAppContext} from "../../AppContext"
import CodeInput from "../CodeInput"

const Login2Auth: FC = () => {
  const [formFields, setFormFields] = useState<any>({code: ''})
  const [formValidators, setFormValidators] = useState<any>({
    code: Yup.string()
      .required('Field can not be empty')
      .length(6, 'Code must be exactly 6 characters')
  })
  const [type, setType] = useState<string>('')
  const {appType} = useAppContext()
  const {authType} = useParams()

  useEffect(() => {
    if ( authType ) {
      if ( authType === 'ta' ) setType('telegram')
      if ( authType === 'ma' ) setType('mail')
      if ( authType === 'ga' ) setType('google')
    }
  }, [authType])

  useEffect(() => {
    if ( type ) codeSend(type)
  }, [type])

  return (
    <>
      <MetaTags>
        <title>{getLocalizeString('Sign in')}</title>
      </MetaTags>

      <Form2Auth
        title={'Log in '}
        initFields={formFields}
        validationSchema={Yup.object().shape(formValidators)}
        type={type}
        onSubmit={(values, actions) => {
          codeCheck(type, values.code)
            .then(res => {
              if ( res.status ) redirect(appType, true)
            })
            .finally(() => actions?.setSubmitting(false))
        }}
      >
        {({isSubmitting}) => (
          <>
            <div className={'form-block'}>
              <CodeInput />
            </div>

            <Button
              text={'Log in'}
              type={'blue'}
              submit
              size={(appType === 'pro') ? 'big' : ''}
              isLoading={isSubmitting}
            />
          </>
        )}
      </Form2Auth>
    </>
  )
}

export default Login2Auth
